import { Decimal } from 'decimal.js-light';

export function formatDollars(numberToFormat: number): string {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });

  return formatter.format(numberToFormat);
}

export function parseCurrencyStringToDecimal(stringToFormat: string): Decimal {
  if (!stringToFormat) {
    return new Decimal('0');
  }
  const stringWithNoSpecialChars =
    removeSpecialCharFromCurrencyString(stringToFormat);

  return new Decimal(stringWithNoSpecialChars);
}

export function removeSpecialCharFromCurrencyString(
  stringToFormat: string,
): string {
  return stringToFormat.replace(/[^0-9.-]/g, '');
}
